<template>
  <div class="services-container">
    <div class="services-title">
      <h1>NOS SERVICES</h1>
    
    </div>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/services">Services</a>
      </div>
    <div class="supracare-description">
      <h2>Service de conseil</h2>
      <p>
        Supracare offre des services de conseil pour aider les laboratoires et les établissements de santé à choisir les meilleures solutions pour leurs besoins.
      </p>

      <h2>Maintenance des équipements</h2>
      <p>
        Nos équipes techniques sont à votre disposition pour assurer l'entretien régulier et la maintenance de vos équipements de laboratoire.
      </p>

      <h2>Formation</h2>
      <p>
        Nous offrons des formations pour garantir l'utilisation optimale des produits que nous fournissons.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage',
};
</script>

<style scoped>
/* Conteneur principal */
.services-container {
  padding: 0px 0px;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-bottom: 500px; /* Ajout d'une marge inférieure pour espacer le footer */
}

/* Ajout d'une superposition transparente */
.services-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

/* Titre avec image de fond */
.services-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/serv.jpeg');
  background-size: cover;
  background-position: center;
  color: rgb(248, 247, 250);
  padding: 80px 400px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

/* Breadcrumb */
.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;

}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

/* Description avec padding et box-shadow */
.supracare-description {
  padding: 50px 300px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); 
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif; 
}

/* Titres dans la description */
.supracare-description h2 {
  color: rgb(86, 80, 80);
  font-size: 25px; 
  margin-bottom: 15px;
  font-family: 'Oswald', Helvetica, Arial, Lucida, sans-serif;
 

}

/* Paragraphes */
.supracare-description p {
  font-size: clamp(1rem, 2vw, 1.2rem); 
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
}



/* Responsive pour les petits écrans */
@media (max-width: 1040px) {
  .services-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* ===================== MODE SOMBRE (auto) ===================== */
@media (prefers-color-scheme: dark){

  /* Fond global + voile plus sombre */
  .services-container{
    background:#0e1720;
    color:#e6edf1;
  }
  .services-container::before{
    background-color: rgba(0,0,0,0.35); /* au lieu du voile blanc */
  }

  /* Bandeau image : contraste renforcé pour le texte */
  .services-title{
    color:#0e0f0f;
    box-shadow: 0 10px 32px rgba(0,0,0,.55);
    position: relative;
  }
  .services-title::after{
    content:""; position:absolute; inset:0; pointer-events:none; border-radius:inherit;
    background: linear-gradient(180deg, rgba(0,0,0,.45), rgba(0,0,0,.25));
  }

  /* Fil d’Ariane */
  .breadcrumb{ color:#9fb3c8; }
  .breadcrumb a{ color:#73d8cf; }
  .breadcrumb a:hover{ color:#a5f3ee; }

  /* Bloc texte principal */
  .supracare-description{
    background:#0f1720;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 24px rgba(0,0,0,.55);
  }
  .supracare-description h2{ color:#e5ecff; }
  .supracare-description p{ color:#cfe0e4; }
}

/* Micro-ajustement sombre sur tablettes/mobile (ombre un peu plus douce) */
@media (prefers-color-scheme: dark) and (max-width:1040px){
  .services-title{ box-shadow: 0 8px 22px rgba(0,0,0,.55); }
}

</style>

